import React from 'react';
import styled from 'styled-components';
import Video from './common/Video';
import Button from './common/Button';

const VideoContainer = styled.section`
	text-align: center;
`;

const ProjectVideos = () => {
	return (
		<div className="container">
			<VideoContainer id="project-videos">
				<Video
					url="https://res.cloudinary.com/dpabcunnn/video/upload/v1627132194/videos/about-safe-up_higm3z.mp4"
					caption="A member of the project team discussing the project's impact by February 2021."
					autoPlay={true}
				/>
				<Button text="Our impact story" anchor="/impact" />
			</VideoContainer>
		</div>
	);
};

export default ProjectVideos;
